module.exports = __webpack_public_path__ + "img/additional-savings-bounce-red.57e66ac2.gif";